import { render } from "./App.vue?vue&type=template&id=5f6570cc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5f6570cc&lang=css"

import exportComponent from "/Users/grant/Desktop/Mindverse/mindverse/mindverse-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__